/**
 * LMS Module Routes
 */

import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

// Lazy load pages
const CourseCatalogPage = React.lazy(() => import('./pages/CourseCatalogPage'))
const MyCoursesPage = React.lazy(() => import('./pages/MyCoursesPage'))

const LMSRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/lms/my-courses" replace />} />
      <Route path="/my-courses" element={<MyCoursesPage />} />
      <Route path="/courses" element={<CourseCatalogPage />} />
    </Routes>
  )
}

export default LMSRoutes
